import React from 'react';
import { ColorSwatch } from '../drawing';
import { IColorColor } from './StudyModal';

interface IStudyOutput {
	color?: string | IColorColor,
	heading?: string,
}

interface IStudyModalOutputProps {
	output: IStudyOutput,
	setColor: (color: string | IColorColor, type: string, name: string | undefined) => void,
	isModal?: boolean,
}

export const StudyModalOutput: React.FunctionComponent<IStudyModalOutputProps> = ({ output, setColor, isModal }) => {
	if (!output) { return (<div />); }
	return (
		<div className="outputs dialog-item">
			{
				output.color ?
					<ColorSwatch
						isModal={isModal || false}
						name={output.heading}
						type="output"
						setColor={setColor}
						color={ typeof output.color === "string" ? output.color : output.color.color}
						top={ 0 } />
					:
						<div />
				}
			<div>
				{output.heading}
			</div>
		</div>
	);
};